import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles'
import { connect } from 'react-redux'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'

import Wrapper from '../../components/Wrapper'
import Header from '../../components/Header'
import Body from '../../components/Body'
import Footer from '../../components/Footer'
import TopBar from '../../components/TopBar'
import SubmitButton from '../../components/SubmitButton'
import Checkbox from '@material-ui/core/Checkbox'

import BackgroundImage from '../../assets/motor/background.png'
import _ from 'lodash'
import numeral from 'numeral'
import { motorService } from '../../services/motor.service'
import Modal from '@material-ui/core/Modal'
import Loading from '../../components/Loading'
import moment from 'moment'

const fontDefault = {
  fontFamily: 'thonburiregular',
  fontStyle: 'normal',
}

const styles = {
  textTopBar: {
    ...fontDefault,
    color: '#333333',
    fontSize: '18px',
    fontWeight: 'bold',
  },
  backgroundImageContainer: {
    position: 'absolute',
    height: '160px',
    width: '100%',
  },
  backgroundImage: {
    height: '160px',
    objectFit: 'cover',
    width: '100%',
  },
  card: {
    borderRadius: '8px',
    boxShadow: '0 2px 4px 0 rgba(94, 92, 92, 0.3)',
    backgroundImage: 'linear-gradient(162deg, #ffffff, #ffffff)',
    margin: '16px',
  },
  cardHeader: {
    backgroundColor: '#ddedfe',
    borderTopLeftRadius: '8px',
    borderTopRightRadius: '8px',
    padding: '16px',
  },
  cardTitle: {
    color: '#118df5',
    fontSize: '18px',
    ...fontDefault,
  },
  cardContent: {
    padding: '16px',
  },
  container: {
    marginTop: '10px',
    position: 'relative',
  },
  fieldTitle: {
    ...fontDefault,
    fontSize: '16px',
    color: '#0e162c',
    display: 'block',
  },
  fieldTitleFade: {
    ...fontDefault,
    fontSize: '16px',
    color: '#999999',
    display: 'block',
    marginTop: '3px',
  },
  inputContainer: {
    marginTop: '7px',
    padding: '16px',
    borderRadius: '8px',
    boxShadow: '0 1px 4px 0 rgba(157, 157, 157, 0.3)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  fieldValueBlank: {
    color: '#cdd2de',
  },
  fieldValue: {
    color: '#0e162c',
  },
  cardHeadTitle: {
    ...fontDefault,
    color: '#0e162c',
    fontSize: '16px',
    fontWeight: 'bold',
    textAlign: 'center',
    display: 'block',
  },
  cardHeadTitleNormal: {
    ...fontDefault,
    color: '#0e162c',
    fontSize: '16px',
    textAlign: 'center',
    display: 'block',
    marginTop: '8px',
  },
  cardHeadTitleFade: {
    ...fontDefault,
    color: '#878b96',
    fontSize: '16px',
    fontWeight: 'bold',
    textAlign: 'center',
    display: 'block',
  },
  cardPrice: {
    ...fontDefault,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontFamily: 'San Francisco Text',
    fontSize: '15.6px',
    fontWeight: 'bold',
    color: '#3f3f3f',
    marginTop: '0px',
    marginBottom: '0px',
  },
  cardPriceNumber: {
    ...fontDefault,
    marginLeft: '8px',
    fontFamily: 'San Francisco Text',
    fontSize: '44.6px',
    fontWeight: 'bold',
    color: '#3f3f3f',
    marginTop: '0px',
    marginBottom: '0px',
  },
  cardReturnContainer: {
    display: 'flex',
    justifyContent: 'center',
  },
  cardReturn: {
    backgroundColor: '#1a63b6',
    borderRadius: '20px',
    padding: '6px',
    paddingLeft: '18px',
    paddingRight: '18px',
  },
  cardReturnText: {
    ...fontDefault,
    color: 'white',
    fontWeight: 'bold',
    fontSize: '12px',
  },
  cardReturnTextNumber: {
    ...fontDefault,
    color: 'white',
    fontFamily: 'San Francisco Text',
    fontWeight: 'bold',
    fontSize: '18px',
  },
  agreeContainer: {
    display: 'flex',
  },
  agreeDetailContainer: {
    width: '100%',
  },
  agreeTitle: {
    marginTop: '12px',
    marginBottom: '0px',
    ...fontDefault,
    color: '#0e162c',
    fontSize: '14px',
    fontWeight: 'bold',
  },
  agreeContent: {
    ...fontDefault,
    color: '#878b96',
    fontSize: '14px',
  },
  marginContainer: {
    margin: '0 32px 0 16px',
  },
  agreeButton: {
    ...fontDefault,
    fontSize: '14px',
    color: '#118df5',
    marginBottom: '0px',
  },
}

const dateStringToText = (inputdate = '0001-01-01') => {
  const date = new Date(inputdate + 'T07:00:00')
  const day = String(date.getDate()).padStart(2, '0')
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const year = String(date.getFullYear() + 543).slice(-2)
  return day + '/' + month + '/' + year
}

class Br extends Component {
  render = () => {
    return <div style={{ display: 'block', padding: '5px' }} />
  }
}

const CustomCheckbox = withStyles({
  checked: {
    color: '#1a63b6',
  },
})(Checkbox)

class Summary extends Component {
  state = {
    isAgree: false,
    isLoading: false,
    agreementError: false,
  }

  componentDidMount = () => {
    const { userInput } = this.props
    const isAgree = _.get(userInput, 'isAgree', false)
    this.setState({
      isAgree,
    })
  }

  goToAgreement = () => {
    const {
      history: { push },
    } = this.props
    push('/agreement')
    document.getElementById("rootScreen").scrollTo(0, 0)
  }

  goToNextPage = async () => {
    const {
      history: { push },
      setUserInput,
      currentProduct,
      carBrand,
      carModel,
      carYear,
      insuranceClass,
      selectPrice,
    } = this.props
    const { userInput, auth } = this.props
    const token = _.get(auth, 'token', null)
    const splittedFullname = _.get(userInput, 'fullname', '').split(/ +/)
    const currentPackage = _.get(userInput, 'currentPackage', {})
    const first_name = splittedFullname.shift() || ''
    const last_name = splittedFullname.join(' ')
    const stateAddress = _.get(userInput, 'address', '')
    const stateMoreAddress = _.get(userInput, 'moreAddress', {})
    const address =
      stateAddress + ' ' + _.get(stateMoreAddress, 'fullAddress', '')
    const effDate = _.get(userInput, 'effDate', '0001-01-01') || '0001-01-01'
    //const startEffDate = moment(effDate).format('YYYY-MM-DD')
    //const endEffDate = moment(effDate).add(1, 'years').format('YYYY-MM-DD')

    const birthData = new Date(
      _.get(userInput, 'birthdate', '0000-01-01') + 'T07:00:00'
    )
    const effData = new Date(effDate + 'T07:00:00')
    try {
      this.setState({
        isLoading: true,
      })
      const mixpanel = _.get(window, 'mixpanel', undefined)
      if (!!mixpanel) {
        mixpanel.track('Insurance Car Fill Info', {
          'Insurance type':
            currentProduct === 'V'
              ? 'Voluntary Motor Insurance'
              : 'Compulsory Motor Insurance',
          'Insurance class': insuranceClass,
          Amount: selectPrice,
          'Car make': carBrand,
          'Car model': _.get(carModel, 'label', ''),
          'Car registration year': carYear,
        })
        mixpanel.people.set({
          'Car make input': carBrand,
          'Car model input': _.get(carModel, 'label', ''),
          'Car registration year input': carYear,
        })
      }
      let sendingAddress = address
      if (
        sendingAddress &&
        sendingAddress.length === 0 &&
        typeof sendingAddress === 'object' &&
        typeof sendingAddress.join === 'function'
      ) {
        sendingAddress = sendingAddress.join(' ')
      }

      const response2 = await motorService.postUW(token, {
        package_id: parseInt(_.get(currentPackage, 'ID', 0)),
        id_card: _.get(userInput, 'ID', ''),
        title: _.get(userInput, 'gender', ''),
        first_name,
        last_name,
        birth_day: birthData,
        phone_number: _.get(userInput, 'phoneNumber', ''),
        address: sendingAddress,
        sub_district: _.get(userInput, 'moreAddress.subdistrict.name', ''),
        sub_district_code: _.get(
          userInput,
          'moreAddress.subdistrict.tumbon_code',
          ''
        ),
        discount_price: parseFloat(_.get(currentPackage, 'discount_price', 0)),
        district: _.get(userInput, 'moreAddress.district.name', ''),
        district_code: _.get(userInput, 'moreAddress.district.amph_code', ''),
        province: _.get(userInput, 'moreAddress.province.jw_name', ''),
        province_code: _.get(userInput, 'moreAddress.province.jw_code', ''),
        post_code: _.get(userInput, 'moreAddress.subdistrict.zipcode', ''),
        email: _.get(userInput, 'email', ''),
        sum_insured: parseInt(_.get(currentPackage, 'sum_ins', 0)),
        total_prem_vol: parseFloat(_.get(currentPackage, 'total_prem_vol', 0)),
        total_prem_comp:
          currentProduct === 'V'
            ? _.get(userInput, 'isVMIIncludeCMI', false)
              ? parseFloat(_.get(currentPackage, 'total_prem_comp', 0))
              : 0
            : parseFloat(_.get(currentPackage, 'total_prem', 0)),
        coverage_from: effData,
        license_number: _.get(userInput, 'licensePlate', ''),
        plate_province: _.get(userInput, 'plateProvince.abbrv', ''),
        plate_province_name: _.get(userInput, 'plateProvince.name', ''),
        chassis_number: _.get(userInput, 'vehicleID', ''),
        car_brand: _.get(userInput, 'carBrand', ''),
        car_model: _.get(userInput, 'carModel.label', ''),
        car_cc: String(_.get(userInput, 'carModel.x_cc', '')),
        car_code: _.get(userInput, 'carModel.value', ''),
        car_year: String(_.get(userInput, 'carYear', '')),
        car_type: String(_.get(userInput, 'carModel.carType', '')),
      })
      if (response2.status !== 'Success') {
        const mixpanel = _.get(window, 'mixpanel', undefined)
        if (!!mixpanel) {
          mixpanel.track('Insurance Car Error', {
            'Error message': _.get(
              response2,
              'message',
              'UW - UW Error - ' + response2.status
            ),
            'Error code': 'E10601',
          })
        }
        const dataLayer = _.get(window, 'dataLayer', undefined)
        if (!!dataLayer) {
          dataLayer.push({
            event: 'error-page', // Required
            errorMsg: _.get(
              response2,
              'message',
              'UW - UW Error - ' + response2.status
            ),
          })
        }
        push('/error-buy')
        this.setState({
          isLoading: false,
        })
        document.getElementById("rootScreen").scrollTo(0, 0)
        return
      }
      const response = await motorService.postOrder(token, {
        package_id: parseInt(_.get(currentPackage, 'ID', 0)),
        id_card: _.get(userInput, 'ID', ''),
        title: _.get(userInput, 'gender', ''),
        first_name,
        last_name,
        birth_day: birthData,
        phone_number: _.get(userInput, 'phoneNumber', ''),
        address: sendingAddress,
        sub_district: _.get(userInput, 'moreAddress.subdistrict.name', ''),
        sub_district_code: _.get(
          userInput,
          'moreAddress.subdistrict.tumbon_code',
          ''
        ),
        discount_price: parseFloat(_.get(currentPackage, 'discount_price', 0)),
        district: _.get(userInput, 'moreAddress.district.name', ''),
        district_code: _.get(userInput, 'moreAddress.district.amph_code', ''),
        province: _.get(userInput, 'moreAddress.province.jw_name', ''),
        province_code: _.get(userInput, 'moreAddress.province.jw_code', ''),
        post_code: _.get(userInput, 'moreAddress.subdistrict.zipcode', ''),
        email: _.get(userInput, 'email', ''),
        sum_insured: parseInt(_.get(currentPackage, 'sum_ins', 0)),
        total_prem_vol: parseFloat(_.get(currentPackage, 'total_prem_vol', 0)),
        total_prem_comp:
          currentProduct === 'V'
            ? _.get(userInput, 'isVMIIncludeCMI', false)
              ? parseFloat(_.get(currentPackage, 'total_prem_comp', 0))
              : 0
            : parseFloat(_.get(currentPackage, 'total_prem', 0)),
        coverage_from: effData,
        license_number: _.get(userInput, 'licensePlate', ''),
        plate_province: _.get(userInput, 'plateProvince.abbrv', ''),
        plate_province_name: _.get(userInput, 'plateProvince.name', ''),
        chassis_number: _.get(userInput, 'vehicleID', ''),
        car_brand: _.get(userInput, 'carBrand', ''),
        car_model: _.get(userInput, 'carModel.label', ''),
        car_cc: String(_.get(userInput, 'carModel.x_cc', '')),
        car_code: _.get(userInput, 'carModel.value', ''),
        car_year: String(_.get(userInput, 'carYear', '')),
        car_type: String(_.get(userInput, 'carModel.carType', '')),
      })
      setUserInput({
        orderId: response,
      })
      push('/payment')
      this.setState({
        isLoading: false,
      })
      document.getElementById("rootScreen").scrollTo(0, 0)
    } catch (error) {
      this.setState({
        isLoading: true,
      })
      if (error.message === 'Network Error') {
        const mixpanel = _.get(window, 'mixpanel', undefined)
        if (!!mixpanel) {
          mixpanel.track('Insurance Car Error', {
            'Error message': error.message,
            'Error code': 'E10602',
          })
        }
        const dataLayer = _.get(window, 'dataLayer', undefined)
        if (!!dataLayer) {
          dataLayer.push({
            event: 'error-page', // Required
            errorMsg: error.message,
          })
        }
        push('/error-network')
        document.getElementById("rootScreen").scrollTo(0, 0)
        return
      }
      const response = _.get(error, 'response', {})
      const responseStatus = response.status
      if (
        responseStatus === 500 ||
        responseStatus === 403 ||
        responseStatus === 401 ||
        responseStatus === 400
      ) {
        const mixpanel = _.get(window, 'mixpanel', undefined)
        if (!!mixpanel) {
          mixpanel.track('Insurance Car Error', {
            'Error message': _.get(
              response,
              'message',
              _.get(
                response,
                'message',
                'Summary - Unknown error - ' +
                  responseStatus +
                  ' ' +
                  _.get(error, 'message', '')
              )
            ),
            'Error code': 'E10603',
          })
        }
        const dataLayer = _.get(window, 'dataLayer', undefined)
        if (!!dataLayer) {
          dataLayer.push({
            event: 'error-page', // Required
            errorMsg: _.get(
              response,
              'message',
              _.get(
                response,
                'message',
                'Summary - Unknown error - ' +
                  responseStatus +
                  ' ' +
                  _.get(error, 'message', '')
              )
            ),
          })
        }
        push('/error-system')
        document.getElementById("rootScreen").scrollTo(0, 0)
        return
      }
    }
  }

  backButton = () => {
    const {
      history: { push },
    } = this.props
    push('/personal-info')
    document.getElementById("rootScreen").scrollTo(0, 0)
  }

  render() {
    const { classes, userInput, selectPrice, currentProduct } = this.props
    const { agreementError, isAgree, isLoading } = this.state
    const currentPackage = _.get(userInput, 'currentPackage', {})
    let risk = ''
    switch (_.get(currentPackage, 'risk', 0)) {
      case 1:
      case '1':
        risk = '1'
        break
      case 5:
      case '5':
        risk = '2+'
        break
      case 3:
      case '3':
        risk = '3'
        break
      default:
        break
    }
    const effDate = _.get(userInput, 'effDate', '0001-01-01') || '0001-01-01'
    const startEffDate = moment(effDate).format('YYYY-MM-DD')
    const endEffDate = moment(effDate)
      .add(1, 'years')
      .format('YYYY-MM-DD')

    const dateFromTo =
      dateStringToText(startEffDate) + ' - ' + dateStringToText(endEffDate)
    const stateDate = _.get(userInput, 'birthdate', '0000-01-01')
    const birthdate = new Date(
      (stateDate ? stateDate : '0000-01-01') + 'T00:00:00'
    ).toLocaleDateString('th-TH', {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
    })

    const stateAddress = _.get(userInput, 'address', '')
    const stateMoreAddress = _.get(userInput, 'moreAddress', {})
    let sendingAddress = stateAddress
    if (
      sendingAddress &&
      sendingAddress.length === 0 &&
      typeof sendingAddress === 'object' &&
      typeof sendingAddress.join === 'function'
    ) {
      sendingAddress = sendingAddress.join(' ')
    }
    const address =
      sendingAddress + ' ' + _.get(stateMoreAddress, 'fullAddress', '')
    const isVMIIncludeCMI = _.get(userInput, 'isVMIIncludeCMI', false)
    let jsonDetail = {}
    try {
      jsonDetail = JSON.parse(
        _.get(currentPackage, 'packages_more_details', '')
      )
    } catch {}
    let seatMessage
    let carTypeName
    switch (jsonDetail.use_no) {
      case '1.10':
        seatMessage = 'ประเภทรถยนต์ไม่เกิน 7 ที่นั่ง'
        carTypeName = 'รถยนต์'
        break
      case '1.20a':
        seatMessage = 'ประเภทรถตู้ส่วนบุคคลไม่เกิน 12 ที่นั่ง'
        carTypeName = 'รถตู้'
        break
      case '1.40a':
        seatMessage = 'ประเภทรถกระบะบรรทุกส่วนบุคคลไม่เกิน 4 ที่นั่ง'
        carTypeName = 'รถกระบะ'
        break
      default:
        seatMessage = ''
        break
    }
    const carModel = _.get(userInput, 'carModel', {})
    const carType = _.get(carModel, 'carType', 0)
    let vCarTypeName
    let vCarSeatMessage
    switch (carType) {
      case 1:
        vCarTypeName = 'รถยนต์'
        vCarSeatMessage = 'ประเภทรถยนต์ส่วนบุคคลไม่เกิน 7 ที่นั่ง'
        break
      case 3:
        vCarTypeName = 'รถกระบะ'
        vCarSeatMessage = 'ประเภทรถกระบะส่วนบุคคลไม่เกิน 4 ที่นั่ง'
        break
      default:
        vCarTypeName = ''
        vCarSeatMessage = ''
        break
    }

    return (
      <Wrapper>
        <Body style={{ backgroundColor: '#eff0f4' }}>
          <div className={classes.backgroundImageContainer}>
            <img
              alt="background_image"
              className={classes.backgroundImage}
              src={BackgroundImage}
            />
          </div>
          <div className={classes.container}>
            <Grid container>
              <Grid item xs={12}>
                <div className={classes.card}>
                  <div className={classes.cardContent}>
                    {currentProduct === 'V' && (
                      <span className={classes.cardHeadTitle}>
                        ประกันรถยนต์ชั้น {risk}
                      </span>
                    )}
                    {currentProduct === 'C' && (
                      <span className={classes.cardHeadTitle}>
                        พ.ร.บ {carTypeName}
                      </span>
                    )}
                    <p className={classes.cardPrice}>
                      ฿{' '}
                      <span className={classes.cardPriceNumber}>
                        {numeral(selectPrice).format('0,0.00')}
                      </span>
                    </p>
                    <div className={classes.cardReturnContainer}>
                      <div className={classes.cardReturn}>
                        <span className={classes.cardReturnText}>
                          รับเงินคืน{' '}
                          <span className={classes.cardReturnTextNumber}>
                            {numeral(
                              parseFloat(
                                _.get(currentPackage, 'cashback_value', 0)
                              ) +
                                (isVMIIncludeCMI
                                  ? parseFloat(
                                      _.get(
                                        currentPackage,
                                        'cashback_value_cmi',
                                        0
                                      )
                                    )
                                  : 0)
                            ).format('0,0.00')}
                          </span>{' '}
                          บาท
                        </span>
                      </div>
                    </div>
                    {currentProduct === 'V' && isVMIIncludeCMI && (
                      <div>
                        <span className={classes.cardHeadTitleNormal}>
                          พ.ร.บ {vCarTypeName}
                        </span>
                        <span className={classes.cardHeadTitleFade}>
                          {vCarSeatMessage}
                        </span>
                      </div>
                    )}
                    {currentProduct === 'C' && (
                      <div>
                        <span className={classes.cardHeadTitleNormal}>
                          ประกันรถยนต์ส่วนบุคคล
                        </span>
                        <span className={classes.cardHeadTitleFade}>
                          {seatMessage}
                        </span>
                      </div>
                    )}
                  </div>
                </div>

                <div className={classes.card}>
                  <div className={classes.cardHeader}>
                    <span className={classes.cardTitle}>รายละเอียดประกัน</span>
                  </div>
                  <div className={classes.cardContent}>
                    <div className={classes.fieldContainer}>
                      <span className={classes.fieldTitle}>
                        บริษัทประกันภัย
                      </span>
                      <span className={classes.fieldTitleFade}>
                        กรุงเทพประกันภัย
                      </span>
                    </div>
                    <Br />
                    <div className={classes.fieldContainer}>
                      <span className={classes.fieldTitle}>
                        คุ้มครองตั้งแต่วันที่
                      </span>
                      <span className={classes.fieldTitleFade}>
                        {dateFromTo}
                      </span>
                    </div>
                    <Br />
                    <div className={classes.fieldContainer}>
                      <span className={classes.fieldTitle}>
                        รถยนต์ที่คุ้มครอง
                      </span>
                      <span className={classes.fieldTitleFade}>
                        {_.get(userInput, 'carBrand', '')}{' '}
                        {_.get(userInput, 'carModel.label', '')} ปี{' '}
                        {_.get(userInput, 'carYear', '')}
                      </span>
                    </div>
                    <Br />
                    <div className={classes.fieldContainer}>
                      <span className={classes.fieldTitle}>เลขทะเบียนรถ</span>
                      <span className={classes.fieldTitleFade}>
                        {_.get(userInput, 'licensePlate', '')}{' '}
                        {_.get(userInput, 'plateProvince.name', '')}
                      </span>
                    </div>
                    <Br />
                    <div className={classes.fieldContainer}>
                      <span className={classes.fieldTitle}>เลขตัวถัง</span>
                      <span className={classes.fieldTitleFade}>
                        {_.get(userInput, 'vehicleID', '')}
                      </span>
                    </div>
                  </div>
                </div>

                <div className={classes.card}>
                  <div className={classes.cardHeader}>
                    <span className={classes.cardTitle}>
                      รายละเอียดผู้ซื้อประกัน
                    </span>
                  </div>
                  <div className={classes.cardContent}>
                    <div className={classes.fieldContainer}>
                      <span className={classes.fieldTitle}>ชื่อ-นามสกุล</span>
                      <span className={classes.fieldTitleFade}>
                        {_.get(userInput, 'fullname', '')}
                      </span>
                    </div>
                    <Br />
                    <div className={classes.fieldContainer}>
                      <span className={classes.fieldTitle}>
                        เลขที่ประจำตัวบัตรประชาชน
                      </span>
                      <span className={classes.fieldTitleFade}>
                        {_.get(userInput, 'ID', '')}
                      </span>
                    </div>
                    <Br />
                    <div className={classes.fieldContainer}>
                      <span className={classes.fieldTitle}>
                        วัน/เดือน/ปีเกิด
                      </span>
                      <span className={classes.fieldTitleFade}>
                        {birthdate}
                      </span>
                    </div>
                    <Br />
                    <div className={classes.fieldContainer}>
                      <span className={classes.fieldTitle}>ที่อยู่</span>
                      <span className={classes.fieldTitleFade}>{address}</span>
                    </div>
                    <Br />
                    <div className={classes.fieldContainer}>
                      <span className={classes.fieldTitle}>อีเมล</span>
                      <span className={classes.fieldTitleFade}>
                        {_.get(userInput, 'email', '')}
                      </span>
                    </div>
                    <Br />
                    <div className={classes.fieldContainer}>
                      <span className={classes.fieldTitle}>เบอร์โทรติดต่อ</span>
                      <span className={classes.fieldTitleFade}>
                        {_.get(userInput, 'phoneNumber', '')}
                      </span>
                    </div>
                  </div>
                </div>

                {currentProduct === 'V' && (
                  <div className={classes.card}>
                    <div className={classes.cardHeader}>
                      <span className={classes.cardTitle}>
                        รายละเอียดความคุ้มครอง
                      </span>
                    </div>
                    <div className={classes.cardContent}>
                      <div className={classes.fieldContainer}>
                        <span className={classes.fieldTitle}>
                          ความเสียหายต่อตัวรถยนต์
                        </span>
                        {risk === '3' && (
                          <span className={classes.fieldTitleFade}>ไม่มี</span>
                        )}
                        {risk === '2+' && (
                          <div>
                            <span className={classes.fieldTitleFade}>
                              จากการชนกับพาหนะทางบก{' '}
                              {parseInt(_.get(currentPackage, 'sum_ins', 0)) ===
                              0
                                ? 0
                                : numeral(
                                    _.get(currentPackage, 'sum_ins', 0)
                                  ).format('0,0')}{' '}
                              บาท
                            </span>
                            <span className={classes.fieldTitleFade}>
                              สูญหาย/ไฟไหม้{' '}
                              {parseInt(
                                _.get(currentPackage, 'sum_ins_fire_theft', 0)
                              ) === 0
                                ? 0
                                : numeral(
                                    _.get(
                                      currentPackage,
                                      'sum_ins_fire_theft',
                                      0
                                    )
                                  ).format('0,0')}{' '}
                              บาท
                            </span>
                            <span className={classes.fieldTitleFade}>
                              น้ำท่วม ลูกเห็บ ฟ้าผ่า ลมพายุ{' '}
                              {parseInt(
                                _.get(
                                  currentPackage,
                                  'att_sumins.natural_sum_ins',
                                  0
                                )
                              ) === 0
                                ? 0
                                : numeral(
                                    _.get(
                                      currentPackage,
                                      'att_sumins.natural_sum_ins',
                                      0
                                    )
                                  ).format('0,0')}{' '}
                              บาท
                            </span>
                          </div>
                        )}
                        {risk === '1' && (
                          <div>
                            <span className={classes.fieldTitleFade}>
                              จากการชนกับพาหนะทางบก{' '}
                              {parseInt(_.get(currentPackage, 'sum_ins', 0)) ===
                              0
                                ? 0
                                : numeral(
                                    _.get(currentPackage, 'sum_ins', 0)
                                  ).format('0,0')}{' '}
                              บาท
                            </span>
                            <span className={classes.fieldTitleFade}>
                              สูญหาย/ไฟไหม้{' '}
                              {parseInt(
                                _.get(currentPackage, 'sum_ins_fire_theft', 0)
                              ) === 0
                                ? 0
                                : numeral(
                                    _.get(
                                      currentPackage,
                                      'sum_ins_fire_theft',
                                      0
                                    )
                                  ).format('0,0')}{' '}
                              บาท
                            </span>
                            {parseInt(
                              _.get(
                                currentPackage,
                                'att_sumins.natural_sum_ins',
                                0
                              )
                            ) > 0 && (
                              <span className={classes.fieldTitleFade}>
                                น้ำท่วม ลูกเห็บ ฟ้าผ่า ลมพายุ{' '}
                                {parseInt(
                                  _.get(
                                    currentPackage,
                                    'att_sumins.natural_sum_ins',
                                    0
                                  )
                                ) === 0
                                  ? 0
                                  : numeral(
                                      _.get(
                                        currentPackage,
                                        'att_sumins.natural_sum_ins',
                                        0
                                      )
                                    ).format('0,0')}{' '}
                                บาท
                              </span>
                            )}
                          </div>
                        )}
                      </div>
                      <Br />
                      <div className={classes.fieldContainer}>
                        <span className={classes.fieldTitle}>
                          ความรับผิดชอบต่อบุคคลภายนอก
                        </span>
                        <span className={classes.fieldTitleFade}>
                          ความเสียหายต่อชีวิต ร่างกาย หรืออนามัย / คน{' '}
                          {parseInt(_.get(currentPackage, 'tpbi_per', 0)) === 0
                            ? 0
                            : numeral(
                                _.get(currentPackage, 'tpbi_per', 0)
                              ).format('0,0')}{' '}
                          บาท
                        </span>
                        <span className={classes.fieldTitleFade}>
                          ความเสียหายต่อชีวิต ร่างกาย หรืออนามัย / ครั้ง{' '}
                          {parseInt(_.get(currentPackage, 'tpbi_acc', 0)) === 0
                            ? 0
                            : numeral(
                                _.get(currentPackage, 'tpbi_acc', 0)
                              ).format('0,0')}{' '}
                          บาท
                        </span>
                        <span className={classes.fieldTitleFade}>
                          ความเสียหายต่อทรัพย์สิน/ครั้ง{' '}
                          {parseInt(_.get(currentPackage, 'tppd', 0)) === 0
                            ? 0
                            : numeral(_.get(currentPackage, 'tppd', 0)).format(
                                '0,0'
                              )}{' '}
                          บาท
                        </span>
                      </div>
                      <Br />
                      <div className={classes.fieldContainer}>
                        <span className={classes.fieldTitle}>
                          ความคุ้มครองตามเอกสารแนบท้าย
                        </span>
                        <span className={classes.fieldTitleFade}>
                          อุบัติเหตุส่วนบุคคล/คน{' '}
                          {risk === '2+' || risk === '1'
                            ? '(รถยนต์ 6 คน, รถกระบะ 2 คน)'
                            : '(รถยนต์ 7 คน)'}{' '}
                          {parseInt(_.get(currentPackage, 'c123_driver', 0)) ===
                          0
                            ? 0
                            : numeral(
                                _.get(currentPackage, 'c123_driver', 0)
                              ).format('0,0')}{' '}
                          บาท
                        </span>
                        <span className={classes.fieldTitleFade}>
                          ค่ารักษาพยาบาล{' '}
                          {parseInt(_.get(currentPackage, 'medical', 0)) === 0
                            ? 0
                            : numeral(
                                _.get(currentPackage, 'medical', 0)
                              ).format('0,0')}{' '}
                          บาท
                        </span>
                        <span className={classes.fieldTitleFade}>
                          ค่าประกันตัวผู้ขับขี่ในคดีอาญา{' '}
                          {parseInt(_.get(currentPackage, 'bailbond', 0)) === 0
                            ? 0
                            : numeral(
                                _.get(currentPackage, 'bailbond', 0)
                              ).format('0,0')}{' '}
                          บาท
                        </span>
                        {risk === '1' && <br />}
                        {risk === '1' && (
                          <span className={classes.fieldTitleFade}>
                            ภัยก่อการร้าย{' '}
                            {parseInt(_.get(currentPackage, 'sum_ins', 0)) === 0
                              ? 0
                              : numeral(
                                  _.get(currentPackage, 'sum_ins', 0)
                                ).format('0,0')}{' '}
                            บาท
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                )}
              </Grid>
            </Grid>
            <div className={classes.marginContainer}>
              <div className={classes.agreeContainer}>
                <div className={classes.checkContainer}>
                  <CustomCheckbox
                    style={{
                      float: 'left',
                      width: '5%',
                      padding: '9px 0px 9px 9px',
                    }}
                    checked={isAgree}
                    onChange={event => {
                      this.setState({
                        isAgree: event.target.checked,
                        agreementError: false,
                      })
                    }}
                    color="#1a63b6"
                    inputProps={{
                      'aria-label': 'secondary checkbox',
                    }}
                  />
                </div>
                <div className={classes.agreeDetailContainer}>
                  <p
                    className={classes.agreeTitle}
                    onClick={() => {
                      this.setState({
                        isAgree: !isAgree,
                        agreementError: false,
                      })
                    }}
                  >
                    ข้าพเจ้ายอมรับทั้งหมด
                  </p>
                  <p className={classes.agreeTitle}>
                    ข้าพเจ้ารับรองว่า ข้อความข้างต้นนี้เป็นความจริงทุกประการ
                  </p>
                  <span className={classes.agreeContent}>
                    ผู้ขอประกันภัยต้องตอบคำถามตามความเป็นจริงทุกข้อ
                    การปกปิดข้อเท็จจริงใดๆ หรือการแถลงข้อความ
                    อันเป็นเท็จจะมีผลให้สัญญาประกันภัยนี้ตกเป็นโมฆียะ
                    อาจจะเป็นเหตุให้บริษัทผู้รับประกันภัยปฏิเสธ
                    ความรับผิดตามสัญญาประกันภัยหรือบอกล้างสัญญาประกันภัยได้
                    ตามประมวลกฎหมายแพ่งและพาณิชย์ มาตรา 865
                  </span>
                  <p className={classes.agreeTitle}>
                    อนุญาตให้บมจ.กรุงเทพประกันภัยเข้าถึงข้อมูลทรูมันนี่
                    วอลเล็ทของท่าน
                  </p>
                  <span className={classes.agreeContent}>
                    ข้อมูลส่วนตัวสำหรับสมัครประกันภัย และอนุญาตการชำระเงิน
                  </span>
                  <p
                    className={classes.agreeButton}
                    onClick={this.goToAgreement}
                  >
                    ข้อกำหนดเเละเงื่อนไขประกัน และรายการส่งเสริมการขาย
                  </p>
                  {agreementError && (
                    <p
                      style={{ fontSize: '12px', ...fontDefault, color: 'red' }}
                    >
                      กรุณาตอบรับเงื่อนไข "ข้อกำหนดและเงื่อนไข" และ
                      "นโยบายความเป็นส่วนตัว"
                    </p>
                  )}
                </div>
              </div>
            </div>
          </div>
          <Modal
            styles={{ outline: 0 }}
            open={isLoading}
            onClose={() => {
              this.setState({ modalVisible: false })
            }}
          >
            <Loading />
          </Modal>
        </Body>
        <Footer style={{ backgroundColor: '#eff0f4' }}>
          <SubmitButton
            onClick={
              isAgree
                ? this.goToNextPage
                : () => {
                    this.setState({
                      agreementError: true,
                    })
                  }
            }
          >
            ยืนยันข้อมูล
          </SubmitButton>
        </Footer>
        <Header>
          <TopBar arrowLeft={this.backButton}>
            <Typography align="center" className={classes.textTopBar}>
              สรุปความคุ้มครอง
            </Typography>
          </TopBar>
        </Header>
      </Wrapper>
    )
  }
}
const mapStateToProps = (state, ownProps) => {
  return {
    userInput: _.get(state, 'motor.userInput', {}),
    auth: state.auth,
    selectPrice: _.get(state, 'motor.userInput.selectPrice', 0),
    currentProduct: _.get(state, 'motor.userInput.currentProduct', ''),
    carBrand: _.get(state, 'motor.userInput.carBrand', ''),
    carModel: _.get(state, 'motor.userInput.carModel', ''),
    carYear: _.get(state, 'motor.userInput.carYear', ''),
    insuranceClass: _.get(state, 'motor.userInput.insuranceClass', ''),
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    setUserInput: data => {
      dispatch({
        type: 'USER_INPUT',
        data,
      })
    },
  }
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(Summary))
